import dayJs from 'dayjs'
/**
 *  金额保留两位小数点
 */
export function filterDecAmount (v) {
  v = v.replace(/[^\d.]/g, '')
  v = v.replace(/\.{2,}/g, '.')
  v = v.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
  v = v.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
  if (v.indexOf('.') < 0 && v !== '') {
    v = parseFloat(v)
  }
  return v
}
/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

/**
 * 时间查询格式化 开始时间格式化成YYYY-MM-DD 00:00:00 结束时间格式化成YYYY-MM-DD 23:59:59
 * @param obj
 * @param time
 * @param flag
 */

export function formatTime (obj, time, flag) {
  // flag标志是不是结束日期 可以传1、true
  return time ? obj.$dayjs(flag ? new Date(time).setHours(23, 59, 59) : time).format('YYYY-MM-DD HH:mm:ss') : ''
}
/**
 *  获取每个月的第一天
 */
export function getFirstDayOfCurrentMonth () {
  return dayJs(`${dayJs().year()}-${dayJs().month() + 1}-01`)
}
